'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AGENT = exports.AGENT = 'AGENT';
var VISITOR = exports.VISITOR = 'VISITOR';
var BOT = exports.BOT = 'BOT';
var SYSTEM = exports.SYSTEM = 'SYSTEM';